import './LoadingBar.css'
import React from 'react'

interface IProps {
    loading: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [otherProps: string]: any;
}
const LoadingBar = ({ loading, otherProps }: IProps) => (
    <div>
        {
            loading
                ? <div className='loading-bar-visible' {...otherProps} />
                : <div className='loading-bar-hidden' {...otherProps} />
        }
    </div>)

export default LoadingBar